const questions = [
    {
        type: "text",
        text: "question 1",
        answer: ""
    },
    {
        type: "text",
        text: "question 2",
        answer: ""
    },
    {
        type: "boolean",
        text: "question 3",
        options: ["Male", "Female"],
        answer: ""
    },
    {
        type: "boolean",
        text: "question 4",
        options: ["Chevy", "Ford", "Mazda", "Mitsubishi"],
        answer: ""
    }
]

export default questions;